export const GET_PROCESOS_REQUEST = 'GET_PROCESOS_REQUEST';
export const GET_PROCESOS_SUCCESS = 'GET_PROCESOS_SUCCESS';
export const GET_PROCESOS_FAILURE = 'GET_PROCESOS_FAILURE';
export const RESET_PROCESOS = 'RESET_PROCESOS';
